import {
  brandCaptionLowerThird,
  BrandCaptionLowerThird,
  brandEntityId,
  BrandEntityId,
  RoomId,
  roomId
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandCaptionLowerThirdCreateRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandCaptionLowerThirdCreateRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomBrandCaptionLowerThirdCreateRequest) {
    JsonSchemaValidator.assert(
      RoomBrandCaptionLowerThirdCreateRequestDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandId", "caption"],
      properties: {
        roomId,
        brandId: brandEntityId,
        caption: brandCaptionLowerThird
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandCaptionLowerThirdCreateRequest {
  roomId: RoomId;
  brandId: BrandEntityId;
  caption: BrandCaptionLowerThird;
}
